import React from "react";
import { motion } from "framer-motion";
import { Check, Minus } from "lucide-react";

const rows = [
  { label: "Régimen fiscal", a: "Régimen suspensivo: impuesto no devengado", b: "Impuesto ya devengado (tipo reducido o exento)" },
  { label: "Liquidez", a: "Capital liberado hasta la puesta a consumo", b: "Impuesto pagado al ingreso en almacén" },
  { label: "Autorización", a: "Autorizado por la AEAT como depósito fiscal", b: "Autorizado como almacén fiscal" },
  { label: "Movimientos UE", a: "Movimiento libre por la UE en suspenso", b: "Limitado al ámbito nacional" },
  { label: "Cliente típico", a: "Importadores, traders y mayoristas", b: "Distribuidores y consumidores finales" },
  { label: "Documentación", a: "EMCS, ARC, garantías AEAT", b: "Documentación simplificada" },
];

export const Comparison = () => {
  return (
    <section
      data-testid="comparison-section"
      className="relative bg-[#0A1628] py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.05]" style={{
        backgroundImage: "radial-gradient(circle at 20% 30%, #0066FF 0%, transparent 50%)",
      }} />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B00] font-semibold">
            Conceptos clave
          </span>
          <h2
            className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight"
            style={{ fontFamily: "Poppins" }}
          >
            Depósito fiscal vs Almacén fiscal.
          </h2>
          <p className="mt-5 text-slate-300 text-lg">
            En ambos casos gestionamos la extracción y la parte fiscal,
            colaborando con instalaciones autorizadas por la AEAT.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mt-12 bg-gradient-to-br from-[#1E3A5F]/40 to-[#0A1628]/40 backdrop-blur-md border border-white/10 rounded-3xl overflow-hidden"
          data-testid="comparison-table"
        >
          <div className="grid grid-cols-1 md:grid-cols-12 border-b border-white/10">
            <div className="md:col-span-3 p-5 bg-white/5 text-slate-300 text-xs uppercase tracking-[0.18em] font-semibold flex items-center">
              Criterio
            </div>
            <div className="md:col-span-5 p-5 bg-[#0066FF]/10 border-l border-white/5">
              <div className="flex items-center gap-3">
                <Check className="w-5 h-5 text-[#0066FF]" />
                <span className="text-white font-semibold" style={{ fontFamily: "Poppins" }}>
                  Depósito fiscal
                </span>
              </div>
              <div className="mt-1 text-xs text-slate-400 uppercase tracking-wider">Régimen suspensivo</div>
            </div>
            <div className="md:col-span-4 p-5 bg-[#FF6B00]/10 border-l border-white/5">
              <div className="flex items-center gap-3">
                <Minus className="w-5 h-5 text-[#FF6B00]" />
                <span className="text-white font-semibold" style={{ fontFamily: "Poppins" }}>
                  Almacén fiscal
                </span>
              </div>
              <div className="mt-1 text-xs text-slate-400 uppercase tracking-wider">Impuesto devengado</div>
            </div>
          </div>

          {rows.map((r, i) => (
            <div
              key={r.label}
              className={`grid grid-cols-1 md:grid-cols-12 border-b border-white/5 last:border-b-0 ${i % 2 === 1 ? "bg-white/[0.02]" : ""}`}
              data-testid={`comparison-row-${i}`}
            >
              <div className="md:col-span-3 p-5 text-slate-300 font-medium text-sm">{r.label}</div>
              <div className="md:col-span-5 p-5 text-slate-200 border-l border-white/5">{r.a}</div>
              <div className="md:col-span-4 p-5 text-slate-200 border-l border-white/5">{r.b}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Comparison;
